import { CheckCircleOutlined, FileOutlined } from "@ant-design/icons";
import Button from "../../../Helpers/Button/Button";
import trans from "../../../../utils";

function ProgressBar({ completed, total }) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="forms-progress-container">
      <div className="forms-progress-header">
        <p className="fs-16 fw-700 brand-700">{trans("Forms Progress")}</p>
        <p className="forms-progress-info">
          {completed}/{total} {trans("completed")} ({percentage}%)
        </p>
      </div>

      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

function FormCard({ form, setFormPopup, formPopup, setFormSubmissionPopup }) {
  console.log("form:", form);
  const viewForm = () => {
    if (form.isSubmitted) {
      setFormSubmissionPopup(form?.submissions?.[0]?.id);
    } else {
      setFormPopup(form?.formId);
    }
  };
  return (
    <div className="form-card">
      <div className="d-flex align-items-center gap-3">
        <div className="form-card-icon">
          <img src={`${process.env.PUBLIC_URL}/assets/files.svg`} />
        </div>
        <p className="form-card-name">
          {form.order}- {form.form?.name || "No Data"}
        </p>
      </div>

      <div className="form-card-actions">
        {form.isSubmitted && (
          <div className="form-completed-icon">
            <CheckCircleOutlined
              style={{ fontSize: "16px", color: "#0f6936" }}
            />
          </div>
        )}
        <Button
          type={"default"}
          onClick={viewForm}
          text={trans("View Details")}
        />
      </div>
    </div>
  );
}

export function LinkedForms({
  data,
  setFormPopup,
  formPopup,
  setFormSubmissionPopup,
}) {
  const forms = data?.forms;
  const completedForms = forms.filter((form) => form.isSubmitted).length;

  return (
    <div className="w-100 p-3">
      <ProgressBar completed={completedForms} total={forms.length} />

      <div className="mt-4">
        <p className="fs-16 fw-700 brand-700 mb-2">{trans("Linked Forms")}</p>
        <div className="row g-3">
          {forms.map((form) => (
            <div key={form?.form?.id} className="col-12 col-md-6">
              <FormCard
                form={form}
                setFormPopup={setFormPopup}
                setFormSubmissionPopup={setFormSubmissionPopup}
                formPopup={formPopup}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
